import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlightLogsRoutingModule } from '@flyfreely-portal-ui/flight-logs';
import { FEATURE_OUTSTANDING_TASKS_VIEW } from '@flyfreely-portal-ui/flyfreely';
import { OrganisationAdminRoutingModule } from '@flyfreely-portal-ui/organisation-admin';
import { UserProfileRoutingModule } from '@flyfreely-portal-ui/user-profile';
import { FeatureFlagGuard } from 'libs/ui/src/lib/featureFlag.guard';
import { OutstandingTasksSidebarComponent } from '../view/outstanding-tasks-sidebar/outstanding-tasks-sidebar.component';
import { OutstandingTasksViewComponent } from '../view/outstanding-tasks-view/outstanding-tasks-view.component';
import { GeneralTasksRoutingModule } from '../widgets/general-task/general-task-routing/general-task-routing.module';
@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: OutstandingTasksViewComponent,
                canActivate: [FeatureFlagGuard],
                data: { requiredFeatureFlag: FEATURE_OUTSTANDING_TASKS_VIEW },
                runGuardsAndResolvers: 'always',
                children: [
                    {
                        path: 'flightlogs',
                        loadChildren: () => FlightLogsRoutingModule
                    },
                    {
                        path: 'orgadmin',
                        loadChildren: () => OrganisationAdminRoutingModule
                    },
                    {
                        path: 'userprofile',
                        loadChildren: () => UserProfileRoutingModule
                    },
                    {
                        path: 'tasks',
                        loadChildren: () => GeneralTasksRoutingModule
                    }
                ]
            },
            {
                path: '',
                component: OutstandingTasksSidebarComponent,
                outlet: 'sidebar'
            }
        ])
    ],
    exports: [RouterModule]
})
export class OutstandingTasksRoutingModule {}
